import ReconnectingWebSocket from 'reconnecting-websocket';
import EventEmitter from 'events';

export default class WebSocketHelper extends EventEmitter {
  constructor(apiUrl, disableAutoConnect) {
    super();

    const url = window.location.protocol.toLowerCase().startsWith('https')
      ? `wss://${window.location.hostname}/socialmedia`
      : apiUrl.replace(/^https?:\/\//i, 'ws://');
    this.url = url;
    this.connected = false;
    this.socket = disableAutoConnect ? null : this.enable();
    this.clientId = null;
  }

  enable = () => {
    this.socket = new ReconnectingWebSocket(this.url);

    if (this.socket) {
      this.socket.addEventListener('open', this.onOpen);
      this.socket.addEventListener('close', this.onClose);
      this.socket.addEventListener('message', this.onMessage);
    }
  };

  disable = () => {
    this.destroy();
  };

  onClose = () => {
    if (!this.socket) {
      return;
    }
    this.clientId = null;
    this.connected = false;
    this.emit('disconnected');
    console.log(`Disconnected from websocket (${this.url})`);
    // This is necessary since reconnecting-websocket
    // removed the behavior to reconnect on connection close...
    return this.socket._shouldReconnect && this.socket._connect();
  };

  onOpen = () => {
    console.log(`Connected to websocket (${this.url})`);
  };

  onMessage = response => {
    let message = {};
    console.log('Received message from websocket');
    try {
      message = JSON.parse(response.data);
      console.log(message);
    } catch (ex) {
      console.log(response);
      return;
    }

    if (message.type === 'connect') {
      this.clientId = message.data.id;
      this.connected = true;
      this.emit('connected', this.clientId);
    } else {
      this.emit(`${message.source || 'message'}`, message);
    }
  };

  destroy() {
    if (this.socket) {
      this.socket.removeEventListener('open', this.onOpen);
      this.socket.removeEventListener('close', this.onClose);
      this.socket.removeEventListener('message', this.onMessage);
      this.socket.close();
      this.socket = null;
    }
  }
}



// WEBPACK FOOTER //
// ./app/util/websocketHelper.js